import { render, staticRenderFns } from "./ExamMainPage.vue?vue&type=template&id=11e796f0"
import script from "./ExamMainPage.vue?vue&type=script&lang=js"
export * from "./ExamMainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports